import styled, { css } from 'styled-components';


export const ConfiguratorContainer = styled.div<{windowHeight:number, menuStyle:'ifr'|'luxe'|'simple'|'simpleLuxe',menuSide:string,font:string}>`
  position: relative;

  font-family: ${(props)=> props.font == 'Avenir' ? 'Avenir' : 'Montserrat, sans-serif'};
  font-style: normal;
  font-size: 14px;

  display: flex;
  flex-direction:${(props)=> props.menuSide == 'right' ? 'row-reverse' : 'row'};
  justify-content: space-between;

  overflow: hidden;
  overscroll-behavior: none;

  height: 100%;
  max-height: 100vh;
  max-height: ${(props) => `${props.windowHeight}px`}; /* window.innerHeight is safer on mobile devices than just 100% or 100vh. It always excludes top/ bottom menu elements. */

  ${(props) => props.menuStyle === 'luxe' && css`
    background-color: #F0F0F0;
  `}

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		flex-direction: ${(props)=> props.menuSide == 'right' ? 'column-reverse' : 'column'};
    overflow:${(props)=> props.menuStyle == 'simpleLuxe' ? 'hidden auto' : 'hidden'};
    user-select: none;

	  &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;  
    scrollbar-width: none;  
	}
`;